/** Форматирование времени сообщений по-русски. */
export function formatTime(d: Date): string {
  return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
}

export function formatDateTime(d: Date): string {
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)
  const same = (a: Date, b: Date) => a.toDateString() === b.toDateString()
  if (same(d, today)) return `Сегодня, в ${formatTime(d)}`
  if (same(d, yesterday)) return `Вчера, в ${formatTime(d)}`
  return `${d.toLocaleDateString('ru-RU')} ${formatTime(d)}`
}

export function formatDay(d: Date): string {
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
}

/**
 * Сколько прошло — коротко, как в «Активности» у Discord: «5 мин. назад», «3 ч. назад», «вчера»,
 * «4 дн. назад»; старше недели — дата, год только если не нынешний.
 */
export function formatAgo(d: Date, now = new Date()): string {
  const minutes = Math.floor((now.getTime() - d.getTime()) / 60_000)
  if (minutes < 1) return 'только что'
  if (minutes < 60) return `${minutes} мин. назад`
  if (minutes < 24 * 60) return `${Math.floor(minutes / 60)} ч. назад`
  const midnight = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime()
  // по календарю, а не по часам: сыгранное вчера в 23:00 — «вчера» и в 9 утра
  const days = Math.round((midnight(now) - midnight(d)) / 86_400_000)
  if (days <= 1) return 'вчера'
  if (days < 7) return `${days} дн. назад`
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', ...(d.getFullYear() !== now.getFullYear() ? { year: 'numeric' } : {}) })
}
